import { v4 as uuidv4 } from 'uuid'
import { onMounted, onUnmounted } from 'vue'

const queue: Record<string, (e?: UIEvent) => void> = {}

window.addEventListener('resize', (e) => {
  Object.keys(queue).forEach((key) => {
    queue[key](e)
  })
})

function addResizeHandle(fn: (e?: UIEvent) => void) {
  const key = uuidv4()
  queue[key] = fn
  return key
}
function removeRsizeHandle(key: string) {
  delete queue[key]
}

export function resizeInit(fn: (e?: UIEvent) => void, immediately?: boolean) {
  let key = ''
  onMounted(() => {
    key = addResizeHandle(fn)
    if (immediately) {
      fn && fn()
    }
  })
  onUnmounted(() => {
    removeRsizeHandle(key)
  })
}
